import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { FileText, Download, BookOpen } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StudentSyllabus = () => {
  const { token } = useAuth();
  const [syllabus, setSyllabus] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = { Authorization: `Bearer ${token}` };
        const [syllabusRes, enrollmentsRes] = await Promise.all([
          axios.get(`${API_URL}/api/syllabus`),
          axios.get(`${API_URL}/api/enrollments/my`, { headers })
        ]);
        setSyllabus(syllabusRes.data);
        setEnrollments(enrollmentsRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token]);

  const enrolledCourseIds = enrollments.map(e => e.course_id);
  const mySyllabus = syllabus.filter(s => enrolledCourseIds.includes(s.course_id));

  return (
    <DashboardLayout title="Syllabus">
      {loading ? (
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <Card key={i} className="animate-pulse">
              <CardContent className="h-24"></CardContent>
            </Card>
          ))}
        </div>
      ) : mySyllabus.length > 0 ? (
        <div className="space-y-4">
          {mySyllabus.map((item) => (
            <Card key={item.id} className="card-hover" data-testid={`syllabus-${item.id}`}>
              <CardContent className="p-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                    <FileText className="w-6 h-6 text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-semibold truncate">{item.title}</h4>
                    {item.description && (
                      <p className="text-sm text-muted-foreground truncate">{item.description}</p>
                    )}
                  </div>
                  <Button size="sm" asChild>
                    <a href={item.file_url} target="_blank" rel="noopener noreferrer">
                      <Download className="w-4 h-4 mr-2" />
                      Download
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card>
          <CardContent className="py-16 text-center">
            <BookOpen className="w-16 h-16 mx-auto text-muted-foreground/30 mb-4" />
            <h3 className="font-heading text-xl font-semibold mb-2">No Syllabus Available</h3>
            <p className="text-muted-foreground">Syllabus for your enrolled courses will appear here.</p>
          </CardContent>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default StudentSyllabus;
